import enums from './shared/enums';
import foreigners from './admin/foreigners/foreigners';
import foreigner from './admin/foreigners/foreigner';
import foreignerFamily from './foreigner/family';
import foreignerForeigner from './foreigner/foreigner';
import foreignerPermits from './foreigner/permits';
import foreignerMessaging from './foreigner/messaging';
import foreignerQuestionnaires from './foreigner/questionnaires';
import logs from './admin/foreigners/logs';
import messaging from './admin/messaging';
import dashboard from './admin/dashboard';
import notifications from './shared/notifications';
import agency_companies from './admin/cms/agency_companies';
import agency_users from './admin/cms/agency_users';
import clients_companies from './admin/cms/clients_companies';
import clients_users from './admin/cms/clients_users';
import internal_users from './admin/cms/internal_users';
import internal_places from './admin/cms/internal_places';
import internal_faq from './admin/cms/internal_faq';
import permit_documents from './admin/cms/permit_documents';
import permit_action_dates from './admin/cms/permit_action_dates';
import permit_statuses from './admin/cms/permit_statuses';
import permit_types from './admin/cms/permit_types';
import audit_logs from './admin/cms/audit_log';
import faq from './shared/faq';
import profile from './shared/profile';

export default {
  namespaced: true,
  modules: {
    shared: {
      namespaced: true,
      modules: {
        profile,
        enums,
        notifications,
        faq,
      },
    },
    foreigner: {
      namespaced: true,
      modules: {
        family: foreignerFamily,
        foreigner: foreignerForeigner,
        permits: foreignerPermits,
        messaging: foreignerMessaging,
        questionnaires: foreignerQuestionnaires,
      },
    },
    admin: {
      namespaced: true,
      modules: {
        messaging,
        dashboard,
        foreigners: {
          namespaced: true,
          modules: {
            foreigners,
            foreigner,
            logs,
          },
        },
        cms: {
          namespaced: true,
          modules: {
            agency: {
              namespaced: true,
              modules: {
                companies: agency_companies,
                users: agency_users,
              },
            },
            clients: {
              namespaced: true,
              modules: {
                companies: clients_companies,
                users: clients_users,
              },
            },
            internal: {
              namespaced: true,
              modules: {
                users: internal_users,
                places: internal_places,
                faq: internal_faq,
              },
            },
            permitManagement: {
              namespaced: true,
              modules: {
                documents: permit_documents,
                actionDates: permit_action_dates,
                statuses: permit_statuses,
                permitTypes: permit_types,
              },
            },
            logs: {
              namespaced: true,
              modules: {
                audit: audit_logs,
              },
            },
          },
        },
      },
    },
  },
};
